import apiClient from './apiClient';
import createCrudApi from './createCrudApi';

const userClient = apiClient('');
const baseCrud = createCrudApi(userClient, 'users');

// Расширяем crud API дополнительным методом
const userApi = {
    ...baseCrud,

    async getProfile(id) {
        const response = await userClient.get(`/users/profile/${id}`);
        return response.data;
    },

    /**
     * Найти пользователя по telegramId
     * @param {string} telegramId - Telegram ID пользователя
     */
    /**
     * Admin: список всех подключенных кошельков (мульти-кошелёк) с инфой о юзере.
     * GET /users/wallets/all?page=&pageSize=
     */
    async getAllConnectedWallets(page = 1, pageSize = 50) {
        const response = await userClient.get('/users/wallets/all', {
            params: { page, pageSize },
        });
        return response.data; // { items, total, page, pageSize }
    },

    async findByTelegramId(telegramId) {
        try {
            // Пробуем найти через поиск всех пользователей
            const allUsers = await userClient.get('/users');
            const users = Array.isArray(allUsers.data) ? allUsers.data : [];
            const foundUser = users.find(
                (user) => user.telegramId === telegramId || user.telegramId === String(telegramId)
            );
            return foundUser || null;
        } catch (error) {
            console.error("Ошибка при поиске пользователя по telegramId:", error);
            return null;
        }
    }
};

export default userApi;
